import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AlertDialogComponent} from "../app/peticiones/alert-dialog/alert-dialog.component";
import {Environment} from "@angular/cli/lib/config/workspace-schema";
import {environment} from "../environments/environment";

export class GestionesPeticionesComentarios {

    public static prefix:string  = "pgc";

    gestion: number = 0;

    comentario: string = "";

    fichero?: File[];

    usuario?: string;

    created?: Date;

    id?: number;

    visto?: boolean;

}
